import {DefaultSettings, settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import render from './renderers/renderers'
import diff from 'virtual-dom/diff'
import patch from 'virtual-dom/patch'
import createElement from 'virtual-dom/create-element'
import * as Actions from './actions/actions';
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
import {Store} from "redux";
import {AlmeState} from "../../../wireup/AlmeState";
const reduceReducers = (reducers) =>
{
    return (previous, current) =>
        reducers.reduce(
            (p, r) => r(p, current), previous
        );
};

export default class AlmeWindow
{
    public _settings: DefaultSettings;
    public _mutatorModules: any;
    public _childComponents: any;
    public _store: Store<AlmeState> | null = null;
    public _mutators: any;
    public _childRenderers: any;
    public _windowTree: any;
    public _isInitialized: any;
    constructor(passedSettings?: DefaultSettings, mutatorModules: any = [], childComponents: any = [])
    {
        this._settings = passedSettings || settings;
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer()
    {
        let reducers: any = [];

        this._childComponents.forEach((item) => {
            reducers.push(item.getReducer());
        });

        reducers.push(reducer);

        return reduceReducers(reducers);
    }

    initialize(store)
    {
        this._store = store;

        this._mutators = [];

        this._mutatorModules.forEach((item) => {
            this._mutators.push(item.getMutator());
        });

        this._childRenderers = [];

        this._childComponents.forEach((item) => {
            this._childRenderers.push(item.getRenderer());
        });

        this._store?.subscribe(() => {
            this.renderWindow()
        });

        this.initWindow();
    }

    initWindow()
    {
    	let elm = document.getElementById(this._settings.Window.rootId);
        if(!elm)
        { //HM-38 If DOM is not loaded, retry in 500ms.
            setTimeout(() => { this.initWindow() }, 500);
            return;
        }

        let tree = render(this._settings, this._mutators, this._childRenderers, this._store?.getState());

        //HM129: Hide logging behind setting. This setting also controls console logging
        let logEnabled = this._settings.logging.enabled || false;
        
        if(logEnabled)
        {
            console.log(tree);
        }

        let rootNode = createElement(tree);
        if(elm.hasChildNodes())
        {
            let remove: any = elm.firstChild;
            elm.removeChild(remove);
        }
        elm.appendChild(rootNode);

        this._windowTree = tree;
        this._isInitialized = true;

        const trapEnabled = this._settings.Window.enableFocusTrap;
        const escapeKey = this._settings.textConstants.escapeKey || settings.textConstants.escapeKey;
        const minimizeiva = this.buildMinimizeOnClick.bind(this);
        const getminimizestate = this.getMinimizeState.bind(this);
        if(trapEnabled){
            const  focusableElements =
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const modal:any = document.querySelector(`#${this._settings.Window.rootId}`); 
            
            document.addEventListener('keydown', function(e) {
                const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                
                if (!isTabPressed && e.key != escapeKey) {
                    return;
                }
                const focusableContent = modal.querySelectorAll(focusableElements);
                const visibleContent: any = [];

                for (let i = 0, max = focusableContent.length; i < max; i++) {
                    const el = focusableContent[i];
                    const style = window.getComputedStyle(el);
                    if (!((style.display === 'none') || (style.visibility === 'hidden') || (!el.offsetHeight && !el.offsetWidth) || el.disabled === true))
                        visibleContent.push(el);
                }
                
                if(visibleContent.length > 1){
                    const lastFocusableElement: any = visibleContent[visibleContent.length - 1]; 
                    const firstFocusableElement: any = visibleContent[0]; 

                    if (e.shiftKey) {
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); 
                            e.preventDefault();
                        }
                    } 
                    else if (e.key === escapeKey) {

                        if (visibleContent.includes(document.activeElement)) {
                            if (getminimizestate() == false) {
                                minimizeiva();
                                (document.getElementsByClassName(settings.classNames.launchPointText)[0] as HTMLElement).focus();
                            }
                        }

                    }
                    else 
                    {
                        if (document.activeElement === lastFocusableElement) {
                            firstFocusableElement.focus(); 
                            e.preventDefault();
                        }
                    }
                }
                
            });
        }
    }    

    renderWindow()
    {
        if(!this._isInitialized) return;
        let rootDiv  = document.getElementById(this._settings.Window.rootId)?.firstChild as HTMLElement;

        let currentTree = this._windowTree;
        let newTree = render(this._settings, this._mutators, this._childRenderers, this._store?.getState());

        let patches = diff(currentTree, newTree);
        patch(rootDiv, patches);

        this._windowTree = newTree;

    }
    getMinimizeState(): boolean {
        const windowBaseLoc = this._settings.stateLocations.Window.Base;
        const isInputBoxLockedLocation = this._settings.stateLocations.Window.IsMinimized;

        if (windowBaseLoc && isInputBoxLockedLocation) {
            return this._store?.getState()[windowBaseLoc][isInputBoxLockedLocation] || false;
        }
        return false;
    }
    buildMinimizeOnClick()
    {
            const { IsMinimized } = this._settings.stateLocations.Window;
            const { reportingEventRequest } = this._settings.messageConstants;

            this._store?.dispatch(Actions.setMinimize(true, IsMinimized));

            const input = {
                eventName: 'MinimizedClicked',
                eventValue: true,
                messageType: reportingEventRequest,
            };

            sendRequest(input);

            return false;
        
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window/src/window.ts